// Module
var code = `<table class="table" ng-if="\$ctrl.units && \$ctrl.units.length > 0">
  <thead>
    <tr>
      <th class="th--index">#</th>
      <th>Account</th>
      <th>Amount</th>
    </tr>
  </thead>
  <tbody class="gl-category-input__tbody">
    <tr ng-repeat="unit in \$ctrl.units" class="gl-category-input__row">
      <td>{{\$index + 1 }}.</td>
      <td>
        {{unit.fullCode}}
      </td>
      <td>
        <cash ng-model="unit.amount" required ng-disabled="\$ctrl.disableAmount"></cash>
      </td>
    </tr>
  </tbody>
</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/general-ledger/common/gl-category-input.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;